import React,{useEffect, useState} from 'react';
import {FaHome} from 'react-icons/fa';
import {IoIosArrowForward} from 'react-icons/io';
import { NavLink } from 'react-router-dom';
import Aos from "aos";
import "aos/dist/aos.css";


import './PagesAdmin.css';
import { Button, Col, Form, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import AhomePage from '../../AdminPagesComponents/AhomePage';
import AamenitiesPage from '../../AdminPagesComponents/AamenitiesPage';

function PagesAdmin(props) {

    

    useEffect(() => {
        // window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);
    
      const [pagenum,setPagenum]= useState('Home Page')

    function handleChangePage(e){
        setPagenum(e.target.value);
    }

    return (
        <div>
            <div className={props.isOpen?'view222':'view111'}>
             
             <div className='DashboardHeader'>
                 <div className='pull-left'>
                     <div className='page-title'>Pages Management</div>
                 </div>
                 
                 <ol className='pull-right'>
                     <li style={{display:'inline-block'}}>
                         <FaHome style={{verticalAlign:'text-top'}} />
                         <NavLink className='dashLink' to='/admin/dashboard' style={{verticalAlign:'center'}}> Home</NavLink>
                         <IoIosArrowForward style={{verticalAlign:'text-bottom'}} />
                     </li>
                     <li active >Pages Management</li>
                     <li><IoIosArrowForward style={{verticalAlign:'text-bottom'}} /></li>
                     <li>{pagenum}</li>
                 </ol>
             </div>
             <div className='contenu'>
             <div className='cardPage  '>
                        <div className='card-title-group2 '>
                                    <div className='card-title'>
                                        <h6 className='ctitle'>Page Name</h6>
                                        <p>Select the desired page and update its content.</p>
                                    </div>
                                    <div className='card-tools mt-n1 mr-n1'>
                                       {/* <Select options={options} /> */}
                                       <select className='select-box'  value={pagenum} onChange={handleChangePage} >
                                           <option value='Home Page'>Home Page</option>
                                           <option value='Amenities Page'>Amenities Page</option>
                                           <option value='Rooms & suits Page'>Rooms & suits Page</option>
                                           <option value='Sign Up page'>Sign Up page</option>
                                           <option value='Search Result page'>Search Result page</option>
                                           <option value='Luxury Room page'>Luxury Room page</option>
                                           <option value='Delux suite page'>Delux suite page</option>
                                           <option value='Premium suite page'>Premium suite page</option>

                                       </select>

                                    </div>
                            </div>
                    </div>
                    
                   <AhomePage cond={pagenum} />
                   <AamenitiesPage cond={pagenum} />
             </div>
             
         </div>
        </div>
    )
}

export default PagesAdmin
